import { ThunkDispatch } from "core-integration/src/store";
import { unbanLeagueEntry } from "core-integration/src/store/leagues/thunks";
import {
  IBanEntryData,
  IPrivateLeagueAdmin,
} from "core-integration/src/store/leagues/types";
import { Button } from "plos/src/components/buttons/Button";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  headingStyles,
  playerItemWrapper,
  playerListWrapper,
  removeBanWrapper,
} from "./removeBan.css";

interface RemoveBanProps {
  league: IPrivateLeagueAdmin;
}

const RemoveBan = ({ league }: RemoveBanProps) => {
  const { t } = useTranslation("leaguesAndCups");
  const dispatch = useDispatch<ThunkDispatch>();
  const navigate = useLocalizedNavigate();

  const unban = async (leagueId: number, data: IBanEntryData) => {
    await dispatch(unbanLeagueEntry(leagueId, data));
    navigate("/leagues");
  };

  if (!league.bans.length) {
    return null;
  }

  return (
    <div className={removeBanWrapper}>
      <h3 className={headingStyles}>
        {t("removeLeagueSuspensions", "Remove League Suspensions")}
      </h3>
      <p>
        {t(
          "removeLeagueSuspensionsDescription",
          "If a player has a suspension removed, they will need to join the league again.",
        )}
      </p>
      <ul className={playerListWrapper}>
        {league.bans.map((ban) => (
          <li key={ban.entry} className={playerItemWrapper}>
            {ban.player_name}
            <div>
              <Button onPress={() => unban(league.id, { entry: ban.entry })}>
                {t("removeSuspension", "Remove suspension")}
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RemoveBan;
